import { Component } from '@angular/core';

@Component({
  templateUrl: './main.html'
})
export class MainComponent {
}



// WEBPACK FOOTER //
// ./src/app/main/components/main/main.component.ts